import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Moment from 'moment';
import { getActiveLanguage } from '@haldor/ui';
var FromNow = /*#__PURE__*/function (_Component) {
  function FromNow() {
    _classCallCheck(this, FromNow);
    return _callSuper(this, FromNow, arguments);
  }
  _inherits(FromNow, _Component);
  return _createClass(FromNow, [{
    key: "capitalizeFirstLetter",
    value: function capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }, {
    key: "formatDate",
    value: function formatDate() {
      Moment.locale(getActiveLanguage());
      return this.capitalizeFirstLetter(Moment(this.props.children).format('LL'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("time", {
        className: "date",
        dateTime: this.props.children
      }, this.formatDate());
    }
  }]);
}(Component);
export { FromNow as default };